const Footer = () => {
  return (
    <div
      style={{
        textAlign: "center",
        marginBottom: 10,
      }}
    >
      Software Engineer: Mr. Rome Dorado <br/>
      Teacher: Sir Romel Gallardo
    </div>
  );
};

export default Footer;
